import script from "./CompleteSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteSignup.vue?vue&type=script&setup=true&lang=js"

import "./CompleteSignup.vue?vue&type=style&index=0&id=87d1f5da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87d1f5da"]])

export default __exports__